module.exports = __webpack_public_path__ + "img/visitor.0a0230b5.png";